import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/api";

export function useTeam() {
  return useQuery({
    queryKey: ["team"],
    queryFn: () => api.listTeam(),
    staleTime: 30_000,
  });
}

export function useInviteUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.inviteUser,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["team"] });
      qc.invalidateQueries({ queryKey: ["usage"] });
      toast.success("Usuario invitado");
    },
  });
}

export function usePatchTeamMember() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: Parameters<typeof api.patchTeamMember>[1] }) =>
      api.patchTeamMember(id, body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["team"] });
      toast.success("Usuario actualizado");
    },
  });
}

export function useRemoveTeamMember() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.removeTeamMember,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["team"] });
      qc.invalidateQueries({ queryKey: ["usage"] });
      toast.success("Usuario eliminado");
    },
  });
}
